import React, { useState, useEffect, useCallback, useContext } from "react";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import _ from "lodash";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { ActionContext } from "context/ActionContext";
import { ActionPlansContext } from "context/ActionPlansContext";
import UserService from "services/UserService";
import {
  putAction,
  getAction,
  getSite,
  postActionImpact,
} from "services/ConfigServices";
import { action as actionVar } from "variables/action";
import { targetedenergywithoutwaterList } from "variables/lists/action";
import {
  energyType,
  equipmentsquantityunitData,
  targetedenergyList,
  consumptionpartunitData,
  productioncapacityunitData,
  investmentcostunitData,
  operationcostunitData,
  cretepowerunitData,
  productioncapacitypvunitData,
  investmentcostpvunitData,
  operationcostpvunitData

} from "variables/lists/action";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  MultiselectCheckbox,
  CustomSelect,
  IntInput,
  TextInput,
} from "components/Input/Index.js";
import { batiment } from "variables/patrimoine.js";

export default function Perimeter({ apiData, closeModal }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const plansContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = plansContext;

  const [newImpact, setNewImpact] = useState({});
  const [newReference, setNewReference] = useState();
  const [patrimoineData, setPatrimoineData] = useState([]);
  const [tertiaryBillData, setTertiaryBillData] = useState({});
  const [unitQuantityValue, setUnitQuantityValue] = useState("");
  const [unitCostValue, setUnitCostValue] = useState("");
  const params = 'perimeter';

  const handleEnergyChange = (e) => {
    const { name, value } = e.target;
    console.log(value);
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters.impact,
          targetedenergy: [{ id: value, name: targetedenergyList.find((obj) => obj.id === value).name }]
        },
        [params]: {
          ...prevState.parameters[params],
          [name]: value,
        },
      },
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let actiontmp = {
      ...action,
      parameters: {
        ...action.parameters,
        [params]: { ...action.parameters[params], [name]: value },
      },
    };
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        [params]: { ...prevState.parameters[params], [name]: value },
      },
    }));
  };
  const handleUnitsChange = (e) => {
    const { name, value } = e.target;
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        [params]: { ...prevState.parameters[params], [name]: value },
      },
    }));
    setUnitQuantityValue(value);
    setUnitCostValue(value);
  };

  useEffect(() => {
    setNewImpact(action?.parameters || {});
  }, [action?.parameters?.impact]);

  function totalCounter(array, key) {
    let total = 0;
    for (const element of array) {
      total += +element?.[key];
    }
    return total;
  }

  useEffect(() => {
    let name = 'autoconsumptionrate';
    let value = '';
    let changevalue = false;
    if (action?.parameters?.impact?.renewabletype === 'solarthermal') {
      value = 100;
      changevalue = true;
    }
    else if (action?.parameters?.impact?.renewabletype === 'geothermal') {
      value = 100;
      changevalue = true;
    }
    else if (action?.parameters?.impact?.renewabletype === 'biomass') {
      value = '0';
      changevalue = true;
    }

    if (changevalue) {
      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          [params]: { ...prevState.parameters[params], [name]: value },
        },
      }));
    }
  }, [action?.parameters?.impact?.renewabletype]);
  /*useEffect(() => {
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        [params]: {
          ...prevState?.parameters?.impact,
          equipmentscount:
            totalCounter(
              action.parameters?.impact?.equipments || [],
              "equipmentscount"
            ) || "",
          surface:
            totalCounter(
              action.parameters?.impact?.equipments || [],
              "surface"
            ) || "",
        },
      },
    }));
  }, [action.parameters?.impact?.equipments]);*/

  useEffect(() => {
    async function getPatrimoineDataAPI() {
      let data = [];
      for (let energy of energyType) {
        await axios
          .get(
            getSite(
              action.parameters.general.groups[0],
              "energy." + energy + "." + "reference"
            ),
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${UserService.getToken()}`,
              },
            }
          )
          .then((response) => {
            data.push(response.data.detail?.energy || { [energy]: {} });
          });
      }
      setPatrimoineData(data);
    }
    getPatrimoineDataAPI();

    axios
      .get(getSite(action.parameters.general.groups[0], "tertiarybill"), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        setTertiaryBillData(response.data.detail?.tertiarybill || {});
      });
  }, []);

  useEffect(() => {
    let refConsumptionSource = actionPlans.reference?.refConsumptionSource;
    if (refConsumptionSource == "patrimoine") {
      getPatrimoineData();
    }
    if (refConsumptionSource == "tertiaryBill") {
      getTertiaryBillData();
    }

    let targetedenergy = action.parameters?.impact?.targetedenergy;

    targetedenergy !== undefined &&
      energyType.map((energy) => {
        if (
          action.parameters?.impact?.targetedenergy.find(
            (target) => target.id == energy
          ) !== -1 &&
          newReference?.reference?.[energy + "refconsumption"]?.value !==
          undefined &&
          action.parameters?.impact?.targetedenergy.find(
            (target) => target.id == energy
          )?.value === undefined
        ) {
          let indexFound = action.parameters?.impact?.targetedenergy.findIndex(
            (target) => target.id == energy
          );

          let energyName = targetedenergyList.find(
            (target) => target.id == energy
          ).name;
          let energyValue =
            newReference?.reference?.[energy + "refconsumption"]?.value;

          targetedenergy[indexFound] = {
            id: energy,
            name: energyName,
            value: energyValue,
          };
        }
        setAction((prevState) => ({
          ...prevState,
          parameters: {
            ...prevState.parameters,
            impact: {
              ...prevState.parameters?.impact,
              targetedenergy,
            },
          },
        }));
      });
  }, [action.parameters?.impact?.targetedenergy?.length]);

  const getPatrimoineData = async (event) => {
    pushPatrimoineInNewReference(patrimoineData);
  };

  const getTertiaryBillData = (event) => {
    pushTertiaryInNewReference(tertiaryBillData);
  };

  function pushPatrimoineInNewReference(arr1) {
    let referenceData = {
      ...newReference,
      reference: { ...newReference?.reference },
    };
    let referenceValue = "";
    let referenceDate = "";

    arr1.map((energy) => {
      let energySelected = Object.keys(energy)[0];
      referenceValue = energy[energySelected]?.reference?.referencefinalenergy;
      referenceDate = energy[energySelected]?.reference?.referenceyear;

      if (
        [
          "electricity",
          "gas",
          "fuel",
          "cold",
          "heat",
          "water",
          "propane",
          "wood",
        ].includes(energySelected)
      ) {
        referenceData.reference[energySelected + "refconsumption"] = {
          value: referenceValue,
          date: referenceDate,
        };
      }
    });

    setNewReference(referenceData);
  }

  function pushTertiaryInNewReference(object1) {
    let referenceData = {
      ...newReference,
      reference: { ...newReference?.reference },
    };
    let startdate = object1?.startdate || "";
    for (const [key, value] of Object.entries(object1)) {
      if (
        [
          "electricityrefconsumption",
          "gasrefconsumption",
          "fuelrefconsumption",
        ].includes(key)
      ) {
        referenceData.reference[key] = { value: value, date: startdate };
      } else if (key === "propanekgrefconsumption") {
        referenceData.reference.propanerefconsumption = {
          value: value,
          date: startdate,
        };
      } else if (key === "heatnetworkrefconsumption") {
        referenceData.reference.heatrefconsumption = {
          value: value,
          date: startdate,
        };
      } else if (key === "coldnetworkrefconsumption") {
        referenceData.reference.coldrefconsumption = {
          value: value,
          date: startdate,
        };
      }
    }

    setNewReference(referenceData);
  }

  let url = putAction(action.id);
  console.log(action);

  return (
    <>
      {/* <GridContainer>
        <GridItem xs={10} sm={10} md={12} lg={10}>
          <TextInput
            inputTitle={"Type ENR"}
            textInput={
              batiment.renewables.synthesis[
                action?.parameters?.impact?.equipments?.[0]?.name
              ] || ""
            }
            handleTextInputChange={handleUnitsChange}
            name="renewabletype"
            disabled
          />
        </GridItem>
      </GridContainer> */}
      <GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={10}>
          <CustomSelect
            inputTitle={"Fluide impacté"}
            selectValue={action?.parameters?.[params]?.["energy"] || ""}
            handleSelectValueChange={handleEnergyChange}
            data={action?.parameters?.impact?.renewabletype === 'pv' ? [{ id: 'electricity', name: 'Electricité' }] : targetedenergywithoutwaterList}
            name="energy"
            disabled={!actionplanupdate}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={10}>
          <IntInput
            inputTitle={"Quantité d'équipement"}
            intInput={
              action?.parameters?.[params]?.["equipmentsquantity"] || ""
            }
            handleIntInputChange={handleChange}
            name="equipmentsquantity"
            disabled={!actionplanupdate}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={10}>
          <CustomSelect
            inputTitle={"Unité(s)"}
            selectValue={
              action?.parameters?.[params]?.["equipmentsquantityunit"] || ""
            }
            handleSelectValueChange={handleUnitsChange}
            data={equipmentsquantityunitData}
            name="equipmentsquantityunit"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={10} sm={10} md={12} lg={10}>
          <IntInput
            inputTitle="Surface concernée (m2)"
            intInput={action?.parameters?.[params]?.["surface"] || ""}
            handleIntInputChange={handleUnitsChange}
            name="surface"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={6}>
          {action?.parameters?.impact?.renewabletype === 'pv' &&
            <IntInput
              inputTitle="Puissance crête"
              intInput={action?.parameters?.[params]?.["cretepower"] || ""}
              handleIntInputChange={handleUnitsChange}
              name="cretepower"
              disabled={!actionplanupdate}
            />
          }
          <IntInput
            inputTitle={"Capacité de production"}
            intInput={
              action?.parameters?.[params]?.["productioncapacity"] || ""
            }
            handleIntInputChange={handleChange}
            name="productioncapacity"
            disabled={!actionplanupdate}
          />
          {/* <IntInput
            inputTitle={"Part conso"}
            intInput={action?.parameters?.[params]?.["consumptionpart"] || ""}
            handleIntInputChange={handleChange}
            name="consumptionpart"
            disabled={!actionplanupdate}
          /> */}
          <IntInput
            inputTitle={"Coût investissement"}
            intInput={action?.parameters?.[params]?.["investmentcost"] || ""}
            handleIntInputChange={handleChange}
            name="investmentcost"
            disabled={!actionplanupdate}
          />
          <IntInput
            inputTitle={"Coût d'opération"}
            intInput={action?.parameters?.[params]?.["operationcost"] || ""}
            handleIntInputChange={handleChange}
            name="operationcost"
            disabled={!actionplanupdate}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={4}>
          {action?.parameters?.impact?.renewabletype === 'pv' &&
            <CustomSelect
              inputTitle={"Unité(s)"}
              selectValue={
                action?.parameters?.[params]?.["cretepowerunit"] || ""
              }
              handleSelectValueChange={handleUnitsChange}
              data={cretepowerunitData}
              name="cretepowerunit"
              disabled={!actionplanupdate}
            />
          }
          <CustomSelect
            inputTitle={"Unité(s)"}
            selectValue={
              action?.parameters?.[params]?.["productioncapacityunit"] || ""
            }
            handleSelectValueChange={handleUnitsChange}
            data={action?.parameters?.impact?.renewabletype === 'pv' ? productioncapacitypvunitData : productioncapacityunitData}
            name="productioncapacityunit"
            disabled={!actionplanupdate}
          />
          {/* <CustomSelect
            inputTitle={"Unité(s)"}
            selectValue={
              action?.parameters?.[params]?.["consumptionpartunit"] || ""
            }
            handleSelectValueChange={handleUnitsChange}
            data={consumptionpartunitData}
            name="consumptionpartunit"
            disabled={!actionplanupdate}
          /> */}
          <CustomSelect
            inputTitle={"Unité(s)"}
            selectValue={
              action?.parameters?.[params]?.["investmentcostunit"] || ""
            }
            handleSelectValueChange={handleUnitsChange}
            data={action?.parameters?.impact?.renewabletype === 'pv' ? investmentcostpvunitData : investmentcostunitData}
            name="investmentcostunit"
            disabled={!actionplanupdate}
          />
          <CustomSelect
            inputTitle={"Unité(s)"}
            selectValue={
              action?.parameters?.[params]?.["operationcostunit"] || ""
            }
            handleSelectValueChange={handleUnitsChange}
            data={action?.parameters?.impact?.renewabletype === 'pv' ? operationcostpvunitData : operationcostunitData}
            name="operationcostunit"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={10} sm={10} md={12} lg={10}>
          <IntInput
            inputTitle="Coef CO2 émission économisée (kg eq CO2/kWh)"
            intInput={action?.parameters?.[params]?.["co2cost"] || ""}
            handleIntInputChange={handleUnitsChange}
            name="co2cost"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={10} sm={10} md={12} lg={10}>
          <IntInput
            inputTitle="Prix de l'énergie à la revente (€/kWh)"
            intInput={action?.parameters?.[params]?.["energycost"] || ""}
            handleIntInputChange={handleChange}
            name="energycost"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={10} sm={10} md={12} lg={10}>
          <IntInput
            inputTitle="Prix de l'énergie à l'achat (€/kWh)"
            intInput={action?.parameters?.[params]?.["energycostbuy"] || ""}
            handleIntInputChange={handleChange}
            name="energycostbuy"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={10} sm={10} md={12} lg={10}>
          <IntInput
            inputTitle="Taux d'autoconsommation (%)"
            intInput={action?.parameters?.[params]?.["autoconsumptionrate"] || ""}
            handleIntInputChange={handleChange}
            name="autoconsumptionrate"
            disabled={!actionplanupdate || action?.parameters?.impact?.renewabletype !== 'pv'}
          />
        </GridItem>
      </GridContainer>
    </>
  );
}
